import BreadCrumb from "Components/Common/BreadCrumb";
import React, { useCallback, useState } from "react";
import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Container, CardBody, Card, Input, Label } from "reactstrap";
import { useSelector } from "react-redux";
import { createSelector } from "reselect";
import ImageViewer from "Components/Common/ImageViewer";

const BankAccount = () => {
  document.title = "Bank Account | BuyPass";

  const selectuserProfile = createSelector(
    (state: any) => state.Business,
    (business) => business?.business
  );
  const seller = useSelector(selectuserProfile);
  const [isViewerOpen, setViewerOpen] = useState(false);
  const [currentImage, setCurrentImage] = useState("");

  useEffect(() => {}, [seller]);

  const closeViewer = () => {
    setViewerOpen(false);
  };

  const openViewer = (imageUrl: string) => {
    setCurrentImage(imageUrl);
    setViewerOpen(true);
  };

  return (
    <div className="page-content bank-account">
      <Container fluid>
        <BreadCrumb
          title=" Bank Account"
          pageTitle="My-Account"
          pageTitleRoute="/my-account-setting"
        />
        <Card>
          <CardBody className="rounded-3">
            <div className="d-grid gap-3 w-50">
              <div>
                <h6 className="fw-bold ">
                  Account Title{" "}
                  <span>
                    <i className="ri-information-line ms-2 fs-5 fw-normal"></i>
                  </span>
                </h6>
                <p className="m-0 p-0">
                  {seller?.idBankDetails?.accountName || "--"}
                </p>
              </div>

              <div>
                <h6 className="fw-bold ">
                  Account Number
                  <span>
                    <i className="ri-information-line ms-2 fs-5 fw-normal"></i>
                  </span>
                </h6>
                <p className="m-0 p-0">
                  {seller?.idBankDetails?.accountNumber || "--"}
                  {/* <span className="text-success cursor-pointer ms-2">Modify</span> */}
                </p>
              </div>

              <div>
                <h6 className="fw-bold ">
                  Bank Name
                  <span>
                    <i className="ri-information-line ms-2 fs-5 fw-normal"></i>
                  </span>
                </h6>
                <p className="m-0 p-0">
                  {seller?.idBankDetails?.bank || "--"}
                  {/* <span className="text-success cursor-pointer ms-2">Modify</span> */}
                </p>
              </div>

              {/* <div >
                                <h6 className="fw-bold ">Bank Code<span><i className="ri-information-line ms-2 fs-5 fw-normal"></i></span></h6>
                                <p className="m-0 p-0">{seller?.idBankDetails?.bankCode || "--"}
                                </p>
                            </div> */}

              <div>
                <h6 className="fw-bold ">
                  IBAN(e.g PK00AAAA0000000000000000)
                  <span>
                    <i className="ri-information-line ms-2 fs-5 fw-normal"></i>
                  </span>
                </h6>
                <p className="m-0 p-0">{seller?.idBankDetails?.Iban || "--"}</p>
              </div>

              <div>
                <h6 className="fw-bold ">
                  SWIFT
                  <span>
                    <i className="ri-information-line ms-2 fs-5 fw-normal"></i>
                  </span>
                </h6>
                <p className="m-0 p-0">
                  {seller?.idBankDetails?.swift || "--"}
                </p>
              </div>

              <div>
                <h6 className="fw-bold">
                  Upload Cheque Copy
                  <span>
                    <i className="ri-information-line ms-2 fs-5 fw-normal"></i>
                  </span>
                </h6>
                {seller?.idBankDetails?.bankDocuments[0]?.url ? (
                  <img
                    data-testing-id="chequeBook"
                    src={seller.idBankDetails.bankDocuments[0].url}
                    alt="Cheque Copy"
                    onClick={() =>
                      openViewer(seller.idBankDetails.bankDocuments[0].url)
                    }
                    style={{
                      width: "100px",
                      height: "100px",
                      objectFit: "cover",
                      borderRadius: "5px",
                      cursor: "pointer",
                    }}
                  />
                ) : (
                  <button
                    type="button"
                    className="btn btn-light"
                    data-testing-Id="uploadChequeButton_backAccount"
                  >
                    {" "}
                    Upload{" "}
                  </button>
                )}
              </div>
              <ImageViewer
                isOpen={isViewerOpen}
                imageUrl={currentImage}
                toggle={closeViewer}
              />

              <div>
                <h6 className="fw-bold ">
                  Branch Name
                  <span>
                    <i className="ri-information-line ms-2 fs-5 fw-normal"></i>
                  </span>
                </h6>
                <p className="m-0 p-0">
                  {seller?.idBankDetails?.bankBranch || "--"}
                </p>
              </div>
            </div>
          </CardBody>
        </Card>
        <Card>
          <CardBody className="rounded-3 text-end">
            <Link to="/bank-account-modify" className="  ">
              <button
                type="button"
                className="btn btn-secondary"
                data-testing-Id="modifyButton_backAccount"
              >
                Modify
              </button>
            </Link>
          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

export default BankAccount;
